import * as FluentIcon from '@fluentui/react-icons';
export var LinkIcon = function (props) {
    return FluentIcon.ArrowRight20Filled(props);
};
export var AppsIcon = function (props) {
    return props.size === 'default'
        ? FluentIcon.Apps20Regular(props)
        : FluentIcon.Apps24Regular(props);
};
export var AppsIconSelected = function (props) {
    return props.size === 'default'
        ? FluentIcon.Apps20Filled(props)
        : FluentIcon.Apps24Filled(props);
};
//# sourceMappingURL=Icons.js.map